import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { SendInvoiceLaterDialogComponent } from './send-invoice-later-dialog.component'

@Injectable({
  providedIn: 'root',
})
export class SendInvoiceLaterDialogService {
  constructor(private dialog: MatDialog) {}

  open(invoiceId: string) {
    const defaultConfig: MatDialogConfig = {
      width: '500px',
      height: 'auto',
      panelClass: ['fixed-modal'],
      data: { invoiceId },
    }

    return this.dialog.open(SendInvoiceLaterDialogComponent, defaultConfig)
  }
}
